import { ExamStatesValue, ExamStatesLabel } from "./constants"
/**
 * 检查状态格式工具
 * @param {*} val 
 */
export function Formatter_examStatesFormatter( val ) {
  for( let key in ExamStatesValue) {
    if(ExamStatesValue[key] == val ) return ExamStatesLabel[key]
  }
  return ''
}


export const Formatter_ageFormatter = ( age ) => {
  return new Date().getFullYear() - new Date(age).getFullYear()
}